<template>
    <div class="content">
        <div class="header flex-row">
            <div class="step-item flex-column">
                <img src="../../assets/img/icon-categoryed.svg" />
                选择预约类型
            </div>
            <div class="step-item flex-column" style="color: #ffffff">
                <img src="../../assets/img/icon-info.svg" />
                填写预约信息
            </div>
            <div class="step-item flex-column">
                <img src="../../assets/img/icon-ordered.svg" />
                确认订单结算
            </div>
            <div class="step-item flex-column">
                <img src="../../assets/img/icon-settlemented.svg" />
                订单预约成功
            </div>
        </div>
        <div class="section">
            <div class="tag flex-row">
                <img src="../../assets/img/icon-left.png" />
                <span>选择日期</span>
                <img src="../../assets/img/icon-right.png" />
            </div>
            <div class="nav flex-row">
                <div class="nav-item flex-column" v-for="(item, index) in navlist" :key="index">
                    {{ item.week }}
                </div>
            </div>
            <div class="datelist flex-row">
                <div
                    class="item flex-column"
                    :class="index == selectIndex ? 'activeDate' : 'notchecked'"
                    v-for="(item, index) in navlist"
                    :key="index"
                    @click="changeDay(index, item.day)"
                >
                    <span>{{ item.day }}</span>
                    <!--					<span v-show="index!=0">2000/2000</span>-->
                    <span v-show="!item.isStopEntering && !item.isReception">可预约</span>
                    <span v-show="item.isStop">闭馆</span>
                    <img
                        class="today"
                        v-show="now == item.day"
                        src="../../assets/img/icon-today.svg"
                    />
                </div>
            </div>
            <div class="tag flex-row">
                <img src="../../assets/img/icon-left.png" />
                <span>选择时段</span>
                <img src="../../assets/img/icon-right.png" />
            </div>
            <div class="timeInterval">
                <div
                    class="item flex-column"
                    v-for="(item, index) in timeList"
                    :key="index"
                    :class="index == timeIndex ? 'activeTime' : 'notchecked'"
                    @click="changeTime(index, item.id)"
                >
                    <span>{{ item.startTime }}-{{ item.endTime }}</span>
                    <span>剩余库存:{{ item.surplusStock }}</span>
                    <span v-show="item.surplusStock > 0">可预约</span>
                    <span v-show="item.surplusStock <= 0">可候补</span>
                    <span style="color: #737373" v-show="item.surplusStock == 0">停售</span>
                </div>
            </div>
            <div class="tag flex-row">
                <img src="../../assets/img/icon-left.png" />
                <span>游客信息</span>
                <img src="../../assets/img/icon-right.png" />
            </div>
            <div class="touristlist">
                <div class="item flex-row" v-for="(item, index) in touristlist" :key="index">
                    <img src="../../assets/img/icon-remove.svg" />
                    <span class="num">{{ index }}</span>
                    <div class="name">
                        <el-input type="text" placeholder="游客姓名" v-model="customerName">
                        </el-input>
                    </div>
                    <div class="phone">
                        <el-input type="text" placeholder="请输入手机号" v-model="customerPhone">
                        </el-input>
                    </div>
                    <el-select v-model="customerIdCardType" placeholder="证件类型">
                        <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        >
                        </el-option>
                    </el-select>
                    <div class="idCard">
                        <el-input type="text" placeholder="请输入证件号码" v-model="customerIdCard">
                        </el-input>
                    </div>
                    <el-select v-model="productNo" placeholder="票种" @change="changeProduct">
                        <!--						<el-option v-for="item in productList" :key="item.productNo" :label="`${item.productName}(${item.price})`" :value="item.productNo">
						</el-option>-->
                        <el-option
                            v-for="item in productList"
                            :key="item.productNo"
                            :label="item.productName"
                            :value="item.productNo"
                        >
                        </el-option>
                    </el-select>
                    <span class="price" v-if="productNo != ''">￥{{ productPrice }}</span>
                </div>
            </div>
            <div class="addBox flex-row">
                <div class="addbtn flex-row">
                    <img src="../../assets/img/icon-add.svg" />
                    手动添加参观者
                </div>
                <div class="uploadbtn flex-row">
                    <img src="../../assets/img/icon-add.svg" />
                    上传身份证照片添加参观者
                </div>
            </div>
            <div class="tag flex-row">
                <img src="../../assets/img/icon-left.png" />
                <span>温馨提示</span>
                <img src="../../assets/img/icon-right.png" />
            </div>
            <div class="tips">
                <div class="detail">
                    <!--富文本内容 -->
                </div>
                <img class="line" src="../../assets/img/icon-line.svg" />
            </div>
            <div class="btnbox flex-row">
                <div class="backbtn cursorp">返回上一步</div>
                <router-link to="FITUnused">
                    <div class="prevbtn cursorp">进入下一步</div>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
name: "FitReservation";
import tool from "../../utils/tools.js";
import { getTimeSlotsLimit, getTicketConfig, getProductList } from "../../utils/http.js";
export default {
    data() {
        return {
            navlist: [
                {
                    week: "星期一",
                    weekE: "MON",
                },
                {
                    week: "星期二",
                    weekE: "TUE",
                },
                {
                    week: "星期三",
                    weekE: "WED",
                },
                {
                    week: "星期四",
                    weekE: "THU",
                },
                {
                    week: "星期五",
                    weekE: "FRI",
                },
                {
                    week: "星期六",
                    weekE: "SAT",
                },
                {
                    week: "星期日",
                    weekE: "SUN",
                },
            ],
            touristlist: [1, 2, 3],
            options: [
                {
                    value: "0",
                    label: "居民身份证",
                },
                {
                    value: "4",
                    label: "护照",
                },
            ],
            configData: {},
            now: tool.formateDate(new Date()),
            timeList: [],
            productList: [],
            value: [],
            selectIndex: 0,
            timeIndex: 0,
            selectTimeId: "",
            selectDay: "",
            customerIdCardType: "0",
            productNo: "",
            customerPhone: "",
            customerName: "",
            customerIdCard: "",
            productPrice: "",
        };
    },
    mounted() {
        this._getTicketConfig("sourceType=2");
        let param = {
            playDay: this.now,
            orderType: 0,
            sourceType: 2,
        };
        this._getTimeSlotsLimit(param);
        this._getProductList("orderType=0&sourceType=2");
    },
    methods: {
        async _getTicketConfig(param) {
            let that = this;
            const res = await getTicketConfig(param);
            if (res.code == 0) {
                that.configData = res.data.config;
                that.navlist = res.data.config.listBuyDays;
                that.navlist.forEach((s, i) => {
                    if (that.now == s.day) {
                        that.selectIndex = i;
                    }
                });
            }
        },
        async _getTimeSlotsLimit(param) {
            let that = this;
            const res = await getTimeSlotsLimit(param);
            if (res.code == 0) {
                that.timeList = res.data;
            } else {
                that.$message.error("获取预约时间失败");
            }
        },
        async _getProductList(param) {
            let that = this;
            const res = await getProductList(param);
            if (res.code == 0) {
                that.productList = res.data;
            } else {
                that.$message.error("获取产品失败");
            }
        },
        changeDay(index, day) {
            this.selectIndex = index;
            this.selectDay = day;
            let param = {
                playDay: day,
                orderType: 0,
                sourceType: 2,
            };
            this._getTimeSlotsLimit(param);
        },
        changeTime(index, timeId) {
            this.timeIndex = index;
            this.selectTimeId = timeId;
        },
        changeProduct(value) {
            let that = this;
            this.productList.forEach(s => {
                if (s.productNo == value) {
                    that.productPrice = s.price;
                }
            });
        },
    },
};
</script>

<style scoped>
.content {
    width: 1200px;
    margin: auto;
    background: #ffffff;
    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.08);
    border-radius: 6px;
    padding: 24px;
    box-sizing: border-box;
}

.header {
    width: 100%;
    height: 70px;
    background-image: url(../../assets/img/step2.svg);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    padding: 0 83px;
    box-sizing: border-box;
    justify-content: space-between;
    margin-bottom: 24px;
}

.header .step-item {
    font-size: 14px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #bb2916;
}

.header .step-item img {
    width: 26px;
    height: 26px;
    margin-bottom: 6px;
}

.header .step-item img:first-child {
    width: 30px;
    height: 24px;
}

.header .step-item img:last-child {
    width: 26px;
    height: 24px;
}

.section {
    width: 100%;
}

.section .nav,
.datelist,
.touristlist,
.tips {
    width: 100%;
    padding: 0 60px;
    box-sizing: border-box;
    justify-content: space-between;
    margin-bottom: 24px;
}

.section .nav .nav-item {
    width: 120px;
    font-size: 14px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #3a6e61;
    line-height: 16px;
}

.section .datelist .item {
    width: 120px;
    height: 80px;
    background: #fbf2e7;
    border-radius: 6px;
    border: 1px solid #bb2916;
    padding: 10px;
    box-sizing: border-box;
    font-size: 14px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 600;
    line-height: 20px;
    color: #bb2916;
    justify-content: center;
    position: relative;
    cursor: pointer;
}

.item .today {
    width: 24px;
    height: 24px;
    position: absolute;
    top: 0;
    right: 0;
}

/* 不可预约样式 */
.notchecked {
    background: #f6f6f6 !important;
    border: 1px solid #eaeaea !important;
    color: #333 !important;
}

/* 日期选中样式 */
.activeDate {
    color: #ffffff !important;
    border: none !important;
    background: #ba2a17 !important;
    background-size: 120px 80px !important;
    background-repeat: no-repeat !important;
}

/* 时段选中样式 */
.activeTime {
    color: #ffffff !important;
    border: none !important;
    background: #ba2a17 !important;
    background-size: 120px 99px !important;
    background-repeat: no-repeat !important;
}
.timeInterval {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
    padding: 0 60px;
    box-sizing: border-box;
    margin-bottom: 24px;
}
.timeInterval .item {
    width: 120px;
    height: 99px;
    background: #f2f8f6;
    border-radius: 6px;
    border: 1px solid #bb2916;
    padding: 10px;
    box-sizing: border-box;
    font-size: 14px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 600;
    line-height: 20px;
    color: #bb2916;
    justify-content: center;
    margin-right: 20px;
    cursor: pointer;
}

.touristlist .item {
    width: 100%;
    height: 70px;
    background: #f5f5f5;
    border-radius: 6px;
    padding: 15px;
    box-sizing: border-box;
    margin-bottom: 12px;
    justify-content: space-between;
}

.touristlist .item img {
    width: 32px;
    height: 32px;
}

.touristlist .item .num {
    font-size: 18px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #000000;
}

.touristlist .item .price {
    font-size: 18px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #bb2916;
}

.addBox {
    justify-content: center;
    font-size: 18px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #3a6e61;
    margin-bottom: 24px;
}

.addBox .addbtn {
    width: 190px;
    height: 40px;
    background: #ffffff;
    border-radius: 6px;
    border: 1px dashed #bb2916;
    justify-content: center;
}

.addBox .uploadbtn {
    width: 288px;
    height: 40px;
    background: #ffffff;
    border-radius: 6px;
    border: 1px dashed #bb2916;
    justify-content: center;
    margin-left: 10px;
}

.addBox img {
    width: 16px;
    height: 16px;
    margin-right: 10px;
}

.tips .line {
    width: 1038px;
    height: 6px;
    margin: 24px 0;
}

.btnbox {
    justify-content: center;
}

.btnbox div {
    width: 324px;
    height: 60px;
    font-size: 22px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    text-align: center;
    line-height: 60px;
    border-radius: 30px;
}

.btnbox .backbtn {
    color: #3a6e61;
    background: #ffffff;
    border: 1px solid #3a6e61;
    margin-right: 32px;
}

.btnbox .prevbtn {
    color: #ffffff;
    background: #bb2916;
}

/deep/ .name .el-input {
    width: 122px;
    height: 40px;
}

/deep/ .phone .el-input {
    width: 166px;
    height: 40px;
}

/deep/ .idCard .el-input {
    width: 256px;
    height: 40px;
}

/deep/ .item .el-input__inner {
    background: #ffffff;
    border: 1px solid #e9ebef;
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #737373;
}

/deep/ .item .el-select {
    width: 120px;
    height: 40px;
    background: #ffffff;
}

/* 输入框focus样式 */
/deep/ .el-select .el-input__inner:focus {
    border-color: #bb2916 !important;
}

/deep/ .el-input__inner:focus {
    border-color: #bb2916;
}
</style>
